// src/components/OfflineStatus.js
import React, { useState, useEffect } from 'react';
import { FaWifi, FaCloudUploadAlt, FaHistory } from 'react-icons/fa';
import { db } from '../firebase';
import { onSnapshotsInSync } from 'firebase/firestore';
import './OfflineStatus.css';

const OfflineStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [isSyncing, setIsSyncing] = useState(false);
    const [showStatus, setShowStatus] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowStatus(true);
            // Ocultar mensaje de "Online" después de unos segundos
            setTimeout(() => setShowStatus(false), 5000);
        };
        const handleOffline = () => {
            setIsOnline(false);
            setShowStatus(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Firestore Sync listener
        const unsubscribeSync = onSnapshotsInSync(db, () => {
            setIsSyncing(true);
            setTimeout(() => setIsSyncing(false), 2000);
        });

        // Inicialmente si está offline, mostrarlo
        if (!navigator.onLine) setShowStatus(true);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            unsubscribeSync();
        };
    }, []);

    if (!showStatus && isOnline && !isSyncing) return null;

    return (
        <div className={`offline-status-container ${isOnline ? 'online' : 'offline'} ${showStatus || isSyncing ? 'visible' : ''} ${isSyncing ? 'syncing' : ''}`}>
            <div className="offline-status-pill">
                {isSyncing ? (
                    <>
                        <FaCloudUploadAlt className="status-icon sync-anim" />
                        <span>Sincronizando cambios...</span>
                    </>
                ) : !isOnline ? (
                    <>
                        <FaWifi className="status-icon offline" />
                        <span>Modo Local: Los cambios se guardarán y subirán al conectar.</span>
                    </>
                ) : (
                    <>
                        <FaWifi className="status-icon online" />
                        <span>Conexión restaurada.</span>
                    </>
                )}
            </div>
        </div>
    );
};

export default OfflineStatus;
